import { baseApi } from 'core/api';

const state = () => ({
    _cache: {},
    _mediaFiles: {},
    _mediaFilesLoading: false,
});

const getters = {
    messageFormCache: (state) => state._cache,
    messageFormMediaFiles: (state) => state._mediaFiles,
    mediaFilesLoading: (state) => state._mediaFilesLoading,
};

const actions = {
    getAttachmentsList() {
        this._setMessageFormLoadingMediaLibrary(true);
        return baseApi.get('core/attachments/list').then((response) => {
            this._setMessageFormLoadMediaLibrary(response.data);
        });
    },

    messageFormCacheMessage(data) {
        this._setMessageFormCacheMessage(data);
    },

    messageFormRemoveCachedMessage(id) {
        this._setMessageFormRemoveCachedMessage(id);
    },

    // Private methods
    _setMessageFormLoadingMediaLibrary(data) {
        this._mediaFilesLoading = data;
    },

    _setMessageFormLoadMediaLibrary(data) {
        this._mediaFiles = data;
        this._mediaFilesLoading = false;
    },

    _setMessageFormCacheMessage({ id, message }) {
        this._cache[id] = message;
    },

    _setMessageFormRemoveCachedMessage(id) {
        if (!this._cache[id]) {
            return;
        }
        delete this._cache[id];
    },
};

export default {
    state,
    getters,
    actions,
};
